// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2DwSq","header":"MessagesList_header__3annt","chat":"MessagesList_chat__2XPvp"};